// src/hooks/useZynth.ts

import { useDispatch, useSelector } from 'react-redux';
import {
  setZynthSlide,
  toggleZynthSlide
} from '../redux/slices/zynthSlideSlice';
import type { RootState, AppDispatch } from '../store';

export const useZynth = () => {
  const dispatch = useDispatch<AppDispatch>();
  const zynthSlide = useSelector((state: RootState) => state.zynth.zynthSlide);
  const enableZynth = () => dispatch(setZynthSlide(true));
  const disableZynth = () => dispatch(setZynthSlide(false));
  const toggleZynth = () => dispatch(toggleZynthSlide());
  const setZynth = (value: boolean) => dispatch(setZynthSlide(value));

  return {
    zynthSlide,
    enableZynth,
    disableZynth,
    toggleZynth,
    setZynth,
  };
};
